import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ROLE_DASHBOARD_MAP = {
  admin: '/admin-dashboard',
  site_manager: '/site-manager-dashboard',
  worker: '/worker-dashboard',
  client: '/client-dashboard',
};

const PWASplashScreen = () => {
  const { isAuthenticated, role, loading, roleLoading } = useAuth();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    // Only run when launched as standalone PWA
    const isStandalone =
      window.matchMedia('(display-mode: standalone)')?.matches ||
      window.navigator?.standalone === true;

    if (!isStandalone) {
      setVisible(false);
      return;
    }

    if (loading || roleLoading) return;

    const timer = setTimeout(() => {
      setVisible(false);
      if (isAuthenticated && role) {
        const destination = ROLE_DASHBOARD_MAP?.[role] || '/admin-dashboard';
        navigate(destination, { replace: true });
      }
    }, 1800);

    return () => clearTimeout(timer);
  }, [loading, roleLoading, isAuthenticated, role, navigate]);

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        backgroundColor: '#0f172a',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '24px',
      }}
    >
      {/* SiteProof Logo */}
      <img
        src="/assets/images/Untitled-1774712732999.jpeg"
        alt="SiteProof"
        style={{
          width: '96px',
          height: '96px',
          borderRadius: '20px',
          objectFit: 'cover',
          boxShadow: '0 0 40px rgba(34, 197, 94, 0.3)',
        }}
      />

      {/* App name */}
      <div style={{ textAlign: 'center' }}>
        <h1
          style={{
            color: '#ffffff',
            fontSize: '28px',
            fontWeight: '700',
            margin: 0,
            letterSpacing: '-0.5px',
          }}
        >
          SiteProof
        </h1>
        <p
          style={{
            color: '#64748b',
            fontSize: '13px',
            margin: '6px 0 0',
            letterSpacing: '0.5px',
            textTransform: 'uppercase',
          }}
        >
          Construction Compliance
        </p>
      </div>

      {/* Loading indicator */}
      <div
        style={{
          width: '40px',
          height: '3px',
          backgroundColor: '#1e293b',
          borderRadius: '2px',
          overflow: 'hidden',
          marginTop: '8px',
        }}
      >
        <div
          style={{
            height: '100%',
            backgroundColor: '#22c55e',
            borderRadius: '2px',
            animation: 'splashProgress 1.6s ease-in-out forwards',
          }}
        />
      </div>

      <style>{`
        @keyframes splashProgress {
          0% { width: 0%; }
          100% { width: 100%; }
        }
      `}</style>
    </div>
  );
};

export default PWASplashScreen;
